import lottie from 'lottie-web';
import { gsap } from "gsap";
import LocomotiveScroll from 'locomotive-scroll';


export default (function () {
  'use strict';

  let elems = document.querySelectorAll('.animation--container');
  let page = document.querySelector('.page-home-data')


  const sectionIds = [];
  const panelTimelines = {};

  let currentSectionId;

if(page){

  function createPanelStartTimeline(container, animation) {
    var panelsStart = gsap.timeline({
      onStart: () => {
        container.classList.add('running')
        animation.setSpeed(0.45)
        animation.playSegments([0,42],true)
      },
    })

    panelsStart.to(container, { duration: 0.5, opacity: 1 }, 0)
      .set(container.querySelector(".copy--wrapper"), { height: 0,  opacity: 0 }, 0)
      .fromTo(container.querySelector(".line"), { scaleY: 0 }, { duration: 8, scaleY: 1 }, 0)
      .fromTo(container.querySelector(".copy--wrapper"), { height: 0, opacity: 0 }, { height: "auto", opacity: 1, duration: 0.5 }, 0)
      .fromTo(container.querySelector(".lottie"), { display: 'none' }, { display: "block", }, 0)

    return panelsStart;
  }

  function createPanelEndTimeline(container, animation) {
    var panelsEnd = gsap.timeline({
      onStart: () => {
        container.classList.remove('running')
        animation.pause()
      },
    })

    panelsEnd.to(container, { duration: 0.5, opacity: 1 }, 0)
      .set(container.querySelector(".lottie"), { display: 'none' }, 0)
      .to(container.querySelector(".line"), { scaleY: 1 }, 0)
      .to(container.querySelector(".copy--wrapper"),{ height: 0, opacity: 0 }, 0)


    return panelsEnd;
  }

  function createPanel(approach) {
    approach.addEventListener('click', handlePanelClick)
    var approachContainer = approach.querySelector('.animations')

    let Data = {
      container: approachContainer,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '/wp-content/themes/acuity-theme/resources/assets/scripts/animations/lottie/' + approachContainer.id + '.json'
    };

    const approachAnim = lottie.loadAnimation(Data);

    var panelStart = createPanelStartTimeline(approach, approachAnim);
    var panelEnd = createPanelEndTimeline(approach, approachAnim);

    panelTimelines[approach.id] = { element: approach, animation: approachAnim, start: panelStart, end: panelEnd, current: null };
    return panelTimelines[approach.id]; //very important that the timeline gets returned
  }

  createPanel(document.querySelector(".collect"))
  createPanel(document.querySelector(".assess"))
  createPanel(document.querySelector(".translate"))
  createPanel(document.querySelector(".evolve"))

  var fullTimeline = gsap.timeline({ repeat: 0 });
  fullTimeline.add(panelTimelines.collect.start)
  .add(panelTimelines.collect.end, 'assessReveal')
  .add(panelTimelines.assess.start, 'assessReveal')
  .add(panelTimelines.assess.end, 'translateReveal')
  .add(panelTimelines.translate.start, 'translateReveal')
  .add(panelTimelines.translate.end, 'evolveReveal')
  .add(panelTimelines.evolve.start, 'evolveReveal')
  .add(panelTimelines.evolve.end)


  // Pause timeline inititally. It gets started by scroll
  fullTimeline.pause()


  function handlePanelClick(event) {
    const panelId = event.currentTarget.id

    // Since click, prevent progression over overall timeline.
    fullTimeline.kill()

    // get currently running timeline panel. Stop its current timline if needed
    let runningPanel = document.querySelector('.running');
    if (runningPanel) {
      if (panelTimelines[runningPanel.id].current) {
        panelTimelines[runningPanel.id].current.pause()
      }

      panelTimelines[runningPanel.id].current = createPanelEndTimeline(panelTimelines[runningPanel.id].element, panelTimelines[runningPanel.id].animation)

      if (panelId == runningPanel.id) {
        return;
      }
    }

    panelTimelines[panelId].current = createPanelStartTimeline(panelTimelines[panelId].element, panelTimelines[panelId].animation)
  }
}

  function showScroll() {

    const scroll = new LocomotiveScroll({
      el: document.querySelector('.acuity--approach-animations'),
    });

    scroll.on('scroll', (args) => {

      if (typeof args.currentElements['translate'] === 'object') {
        // Click this off whenever the person approaches the section. This should likely only ever happen once
        fullTimeline.play()
      } else {
        fullTimeline.pause();
      }
    });
  }

  function init() {
    if(page){
    // approachAnimations()
    showScroll()
    // approachAnims()
  }
  }

  return {

    init: init

  };


  /* eslint-enable no-unused-vars */

})()

